import {
  IApiPreviousAppointment,
  IPreviousAppointment,
  IPreviousAppointmentActivity,
  PreviousAppointmentActivityPerson,
  TMolliePaymentStatus,
} from '../IPreviousAppointment'

export const previousAppointmentTransformer = (
  apiResponse: IApiPreviousAppointment
): IPreviousAppointment => ({
  date: apiResponse.date,
  id: apiResponse.id,
  uuid: apiResponse.uuid,
  token: apiResponse.token,
  hasCabins: apiResponse.has_cabins,
  deposit: apiResponse.deposit
    ? { status: apiResponse.deposit.status as TMolliePaymentStatus }
    : undefined,
  activities: apiResponse.appointment_activities.map(
    (apiActivity): IPreviousAppointmentActivity => ({
      id: apiActivity.id,
      uuid: apiActivity.uuid,
      name: apiActivity.name,
      categoryId: apiActivity.category_id,
      isPersonSelectable: apiActivity.is_person_selectable,
      persons: apiActivity.persons.map((person): PreviousAppointmentActivityPerson => ({
        id: person.id,
        uuid: person.uuid,
        firstName: person.first_name,
        lastName: person.last_name,
        isPreferred: person.is_preferred,
        isCabine: person.is_cabine,
      })),
    })
  ),
})
